import { create } from "zustand";

interface QueryState {
  queryReferralCode: string | null;
  setQueryReferralCode: (code: string | null) => void;
}

export const useQueryStore = create<QueryState>((set) => ({
  queryReferralCode: null,
  setQueryReferralCode: (code) => set({ queryReferralCode: code }),
}));
